import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useSelector } from "react-redux";
import PaymentChart from "./PaymentChart";
import {
  MONTH_LABELS,
  buildYearOptions,
  chartScales,
  chartTooltipStyle,
  YearSelect,
} from "./chartTheme";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const OrdersChart = () => {
  const orders = useSelector((state) => state.AdminOrders.OrderData);
  const years = buildYearOptions();
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [orderCounts, setOrderCounts] = useState(Array(12).fill(0));

  useEffect(() => {
    const filteredOrders = orders?.filter((order) => {
      const orderYear = new Date(order?.createdAt)?.getFullYear();
      return orderYear === selectedYear;
    });

    const counts = Array(12).fill(0);
    filteredOrders?.forEach((order) => {
      const month = new Date(order?.createdAt)?.getMonth();
      counts[month] += 1;
    });

    setOrderCounts(counts);
  }, [selectedYear, orders]);

  const maxCount = Math.max(...orderCounts, 1);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { ...chartTooltipStyle },
    },
    scales: {
      ...chartScales,
      y: {
        ...chartScales.y,
        suggestedMax: maxCount,
      },
    },
  };

  const data = {
    labels: MONTH_LABELS,
    datasets: [
      {
        label: "Total Order Count",
        data: orderCounts,
        backgroundColor: "#E52324",
        borderRadius: 3,
        borderSkipped: false,
      },
    ],
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
      <div className="bg-[#0F172A] border border-[#1a2744] rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-white text-[15px]" style={{ fontWeight: 700 }}>
            Order Chart
          </h3>
          <YearSelect years={years} value={selectedYear} onChange={setSelectedYear} />
        </div>
        <div className="text-[10px] text-white/25 mb-2">
          Orders Chart Month Wise - {selectedYear}
        </div>
        <div className="flex items-center gap-2 mb-3">
          <span className="w-3 h-3 rounded bg-[#E52324]" />
          <span className="text-[10px] text-white/35">Total Order Count</span>
        </div>
        <div className="h-[200px]">
          <Bar options={options} data={data} />
        </div>
      </div>

      <PaymentChart selectedYear={selectedYear} onYearChange={setSelectedYear} years={years} />
    </div>
  );
};

export default OrdersChart;
